var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dismissContainer" }, [
    _c(
      "div",
      {
        staticClass: "expiry-container position-relative pb-0 pt-0 pr-20 pl-20",
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
            [
              _c(
                "div",
                {
                  staticClass: "widget-card p-0 cp cursor-pointer",
                  on: { click: _vm.handlePopup },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "header d-flex flex-between align-items-center",
                      class: _vm.notificationClicked ? "custom-border-0" : "",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "header-content d-flex align-items-center",
                        },
                        [
                          _c("img", {
                            staticClass: "triangle-alert",
                            attrs: {
                              src: "static/images/icons/alert_triangle_white.svg",
                            },
                          }),
                          _c("h3", { staticClass: "title fw-400" }, [
                            _vm._v(_vm._s(_vm.serviceExpiryTitle)),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "custom-arrow center rotate-180 cursor-pointer",
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              icon: "chevron_up_white",
                              imgClass: _vm.notificationClicked
                                ? "full-width rotate-180"
                                : "full-width",
                            },
                            on: { click: _vm.handlePopup },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]
    ),
    _vm.notificationClicked
      ? _c(
          "div",
          {
            staticClass:
              "expiry-container position-relative pb-0 pt-0 pr-20 pl-20",
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-20 pl-20 expiry-div",
                },
                [
                  _c("div", { staticClass: "widget-card p-0 custom-border" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "widget-container d-flex flex-between flex-direction-column",
                      },
                      [
                        _c("div", { staticClass: "list-body" }, [
                          _vm.serviceExpirationList.length > 0
                            ? _c(
                                "section",
                                { staticClass: "service-section" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "list-accordion d-flex flex-between align-items-center",
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "list-header mb-0 mt-0",
                                        },
                                        [_vm._v("Services")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-arrow center rotate-180 cursor-pointer",
                                          on: {
                                            click: _vm.handleServicesPopup,
                                          },
                                        },
                                        [
                                          _c("base-icon", {
                                            attrs: {
                                              icon: "chevron_up_dark_blue",
                                              imgClass:
                                                _vm.serviceNotificationClicked
                                                  ? "rotate-180"
                                                  : "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm.serviceNotificationClicked
                                    ? _c(
                                        "ol",
                                        { staticClass: "list fw-400" },
                                        _vm._l(
                                          _vm.serviceExpirationList,
                                          function (item, index) {
                                            return _c("li", { key: index }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.name) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.getExpiryStatus(
                                                      item.expiry_date
                                                    )
                                                  ) +
                                                  " on " +
                                                  _vm._s(
                                                    _vm._f("UTCDate")(
                                                      item.expiry_date,
                                                      "MM/DD/YYYY"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm.projectExpirationList.length > 0 &&
                          _vm.serviceExpirationList.length > 0
                            ? _c("hr")
                            : _vm._e(),
                          _vm.projectExpirationList.length > 0
                            ? _c(
                                "section",
                                { staticClass: "project-section" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "list-accordion d-flex flex-between align-items-center",
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "list-header mb-0 mt-0",
                                        },
                                        [_vm._v("Smart Builder Projects")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-arrow center rotate-180 cursor-pointer",
                                          on: { click: _vm.handleprojectPopup },
                                        },
                                        [
                                          _c("base-icon", {
                                            attrs: {
                                              icon: "chevron_up_dark_blue",
                                              imgClass:
                                                _vm.projectNotificationClicked
                                                  ? "rotate-180"
                                                  : "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm.projectNotificationClicked
                                    ? _c(
                                        "ol",
                                        { staticClass: "list fw-400" },
                                        _vm._l(
                                          _vm.projectExpirationList,
                                          function (item, index) {
                                            return _c("li", { key: index }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.name) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.getExpiryStatus(
                                                      item.expiry_date
                                                    )
                                                  ) +
                                                  " on " +
                                                  _vm._s(
                                                    _vm._f("UTCDate")(
                                                      item.expiry_date,
                                                      "MM/DD/YYYY"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          (_vm.projectExpirationList.length > 0 ||
                            _vm.serviceExpirationList.length > 0) &&
                          _vm.expiryAddOnList.length > 0
                            ? _c("hr")
                            : _vm._e(),
                          _vm.expiryAddOnList.length > 0
                            ? _c(
                                "section",
                                { staticClass: "team-member-section" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "list-accordion d-flex flex-between align-items-center",
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "list-header mb-0 mt-0",
                                        },
                                        [_vm._v("Team Members")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-arrow center rotate-180 cursor-pointer",
                                          on: { click: _vm.handleExpiryPopup },
                                        },
                                        [
                                          _c("base-icon", {
                                            attrs: {
                                              icon: "chevron_up_dark_blue",
                                              imgClass:
                                                _vm.expiryNotificationClicked
                                                  ? "rotate-180"
                                                  : "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm.expiryNotificationClicked
                                    ? _c(
                                        "ol",
                                        { staticClass: "list fw-400" },
                                        _vm._l(
                                          _vm.expiryAddOnList,
                                          function (item) {
                                            return _c(
                                              "li",
                                              { key: item.name + item.id },
                                              [
                                                _vm._v(
                                                  ' The upgrade for "additional ' +
                                                    _vm._s(item.name) +
                                                    ' over 5" expires on ' +
                                                    _vm._s(
                                                      _vm._f("UTCDate")(
                                                        item.expiry_date,
                                                        "MM/DD/YYYY"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "row reminder-container pt-25 pb-30" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 col-md-6 p-0 custom-checkbox",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "position-relative cust_checkbox",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "checkbox inline-checkbox",
                                      },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.checked,
                                                expression: "checked",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.checked
                                              )
                                                ? _vm._i(_vm.checked, null) > -1
                                                : _vm.checked,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.checked,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.checked = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.checked = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.checked = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _c("span", { staticClass: "cr" }),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "position-relative cursor-none",
                                      },
                                      [
                                        _vm._v(
                                          "Do not show me these reminders again"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 col-md-6 buttons-group",
                              },
                              [
                                !(
                                  _vm.roleId === 1 ||
                                  _vm.roleId === 5 ||
                                  _vm.roleId === 9
                                )
                                  ? _c(
                                      "el-popover",
                                      {
                                        staticClass: "cursor-pointer",
                                        attrs: {
                                          placement: "top-start",
                                          trigger: "hover",
                                          width: "350",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "limit_popover_txt" },
                                          [
                                            _vm._v(
                                              "Account Owners can renew service"
                                            ),
                                          ]
                                        ),
                                        _c("img", {
                                          staticClass: "info-img",
                                          attrs: {
                                            slot: "reference",
                                            src: "/static/images/icons/info_icon.svg",
                                            alt: "info-icon",
                                          },
                                          slot: "reference",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn emergo-green-button renew-btn",
                                    attrs: {
                                      type: "button",
                                      disabled: !(
                                        _vm.roleId === 1 ||
                                        _vm.roleId === 5 ||
                                        _vm.roleId === 9
                                      ),
                                    },
                                    on: { click: _vm.redirectToServices },
                                  },
                                  [_vm._v(" Renew ")]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dismiss font-18 fw-500 cursor-pointer",
                                    on: { click: _vm.notificationDismiss },
                                  },
                                  [_vm._v("Dismiss")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }